<template>
  <div id="app">
    <nav class="navbar">
      <div class="navbar-brand">
        <a class="navbar-item" href="#">
          <img src="./assets/images/logo.svg" alt="" />
        </a>
        <div class="navbar-burger burger" id="navbar-burger" data-target="navBar">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" id="navBar">
        <div class="navbar-start">
        </div>

        <div class="navbar-end">
          <div class="navbar-item is-active" @click="closeMenu"><router-link to="/users">Users</router-link></div>
          <div class="navbar-item" @click="closeMenu"><router-link to="/products">Products</router-link></div>
          <!-- <div class="navbar-item"><a href="https://github.com/LiveLikeCounter/SitooProgrammingAssignment" target="_blank"><b-icon pack="fab" icon="github" size="is-medium"></b-icon></a></div> -->
        </div>
      </div>
    </nav>

    <router-view />
  </div>
</template>

<script>
export default {

  methods: {
    closeMenu() {
      document.getElementById('navBar').className = "navbar-menu"
      document.getElementById('navbar-burger').className = "navbar-burger burger"
    }
  },

  async mounted() {
    document.addEventListener("DOMContentLoaded", () => {
      const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
      if ($navbarBurgers.length > 0) {
        $navbarBurgers.forEach(el => {
          el.addEventListener("click", () => {
            const target = el.dataset.target;
            const $target = document.getElementById(target);

            el.classList.toggle("is-active");
            $target.classList.toggle("is-active");
          });
        });
      }
    });
  }

};
</script>
